import { call, put, takeEvery } from 'redux-saga/effects';
import { searchBikesByBrand } from '../../requests/search_by_brand_request';
import { searchByBrandRequestSuccess, searchByBrandRequestFailure } from '../actions/search_by_brand.actions';
import { SEARCH_BY_BRAND_REQUEST } from '../constants/search_by_brand.constants';
import { SEARCH_BIKE_MODEL_REQUEST } from '../constants/bike_model.constants';

function* searchByBrandRequest({ searchText }) {
    const brands = yield call(searchBikesByBrand, searchText);
    if (brands.result) {
        const ids = brands.options && brands.options.map(({ _id }) => _id);

        yield put({ type: SEARCH_BIKE_MODEL_REQUEST, value: '', brand_id: ids });
        yield put(searchByBrandRequestSuccess(brands.options));
    } else {
        yield put(searchByBrandRequestFailure(brands.error));
    }
}

export default function* searchByBrandSaga() {
    yield takeEvery(SEARCH_BY_BRAND_REQUEST, searchByBrandRequest);
}



// WEBPACK FOOTER //
// ./src/modules/PlatformManagement/BikeManagement/redux/sagas/search_by_brand.saga.js